import { render, staticRenderFns } from "./SimpelbangSection.vue?vue&type=template&id=41df1159&scoped=true&"
import script from "./SimpelbangSection.vue?vue&type=script&lang=js&"
export * from "./SimpelbangSection.vue?vue&type=script&lang=js&"
import style0 from "./SimpelbangSection.vue?vue&type=style&index=0&id=41df1159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41df1159",
  null
  
)

export default component.exports